// extracted by mini-css-extract-plugin
module.exports = {"component":"player-bar_component__PzftD","inner":"player-bar_inner__YXc8l"};